export default "__VITE_ASSET__CK$KYO8U__"